import { ComponentClassNames } from '../../util/classNames';
import { memoizeFunction, mergeStyleSets } from '../../util/styling';

export interface FixedGridColumnStyleProps {
  readonly fixed?: boolean;
  readonly width?: number;
  readonly className?: string;
}

type GetClassNames = (
  fixed: boolean,
  width: number | undefined,
  className: string | undefined
) => ComponentClassNames<'fixedGridColumn'>;
export const getClassNames: GetClassNames = memoizeFunction((fixed, width, className) => {
  const isFixedWithWidth = fixed && width;
  const flexGrow = fixed ? 0 : 1;
  const flexShrink = isFixedWithWidth ? 0 : 1;
  const flexBasis = isFixedWithWidth ? `${width}px` : 'auto';
  const widthValue = isFixedWithWidth ? width : undefined;

  return mergeStyleSets({
    fixedGridColumn: [
      // Need to keep this class name so FixedGridRow can set child styles.
      'y-fixedGridColumn',
      {
        flexGrow,
        flexShrink,
        flexBasis,
        width: widthValue,
        /**
         * Flexible (non-fixed) flex children must have a min-width to allow them to shrink narrower than the
         * possible width of their text content. This is required for ellipsis to work within FixedGridColumn.
         * CSS-Tricks recommends a value of 0px, but manual testing shows a value of 1px is required.
         * https://css-tricks.com/flexbox-truncated-text/
         */
        minWidth: fixed ? 'auto' : 1,
      },
      className,
    ],
  });
});
